<template>
  <span v-if="paymentStatus.text" :class="`text-${paymentStatus.color}`">{{ paymentStatus.text }}</span>
</template>

<script>

export default {
  name: "AdminOrderFeePaymentStatus",
  props: {
    order: Object
  },
  computed: {
    orderData() {
      return this.order;
    },
    isFeePaid() {
      return this.orderData.is_fee_paid;
    },
    transActionStatus() {
      return this.orderData.fee_payment_status;
    },
    paymentStatus() {
      let color = null,
          text = null;
      if (this.transActionStatus) {
        text = this.transActionStatus;
        switch (this.transActionStatus) {
          case 'failed':
            color = 'danger';
            break;
          case 'pending':
            color = 'cyan';
            break;
          case 'settled':
            color = 'success';
            text = 'paid';
            break;
          default:
            color = 'warning';
            break;
        }
      } else if (this.isFeePaid) {
        color = 'success';
        text = 'paid';
      }

      return { text, color }
    }
  }
}
</script>
